import { Form } from 'components/organisms';
import { channelInitialValues } from 'components/organisms/forms/channel/ChannelForm';
import { useParamId } from 'hooks/useParamId';
import { useNavigate } from 'react-router-dom';
import { useGetChannel, useUpdateChannelContracts } from 'services/channel';
import { IChannelMutationForm } from 'services/channel/types/query';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditChannel = () => {
  const channelId = useParamId('channel');
  const navigate = useNavigate();

  const getChannel = useGetChannel(channelId);

  const updateChannelContract = useUpdateChannelContracts();

  const onSubmit = async (values: IChannelMutationForm) => {
    await updateChannelContract.mutateAsync(
      {
        channelId: channelId,
        settlementInfo: values.settlementInfo
          ? {
              contracts: values.settlementInfo.contracts ?? [],
              perVideoSettlement: values.settlementInfo.perVideoSettlement,
            }
          : null,
        version: values.version,
      },
      {
        onSuccess: () => navigate(`/channel/${channelId}/contracts`),
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  return (
    <Form.Channel
      status={{ isLoading: getChannel.isLoading, displayMode: false }}
      i18nextPrefix='channel'
      initialValues={
        getChannel.data
          ? { ...channelInitialValues, ...getChannel.data }
          : channelInitialValues
      }
      onSubmit={onSubmit}
      disableTabs={[1]}
      tittle={getChannel.data?.name ?? '-'}
    />
  );
};

export default EditChannel;
